import { Component, OnInit } from '@angular/core';
import {UserService} from '../../services/user/user.service';
import AppConstants from 'src/app/shared/common-components/AppConstants';
import {User} from '../../services/user/user';
import {UploadComponent} from "../upload/upload.component";
import {AgGridAngular} from "ag-grid-angular";
import {ColDef, ColGroupDef, GridOptions} from "ag-grid-enterprise";
import {DownloadService} from "../../services/download/download";
import {UntypedFormBuilder, UntypedFormControl, Validators} from "@angular/forms";
import {HttpClient} from "@angular/common/http";
import {AlertService} from "../../services/alert/alert.service";
import {ActivatedRoute} from "@angular/router";
import {DownloadAnchorTagComponent} from "../download/download-file.component";
@Component({
    selector: 'app-iff-upload',
    templateUrl: './mou-upload.component.html',
    styleUrls: ['./mou-upload.component.css'],
  imports: [UploadComponent, AgGridAngular]
})
export class MouUploadComponent implements OnInit {
  updateMessagesOptions: GridOptions = this.initializeGridOptions();
  currentUrl: any;
  currentUser: User;
  userRole: any = null;
  businessType: any = null;
  rowData: any;
  public overlayNoRowsTemplate;
  private gridApi;
  columnDefs: (ColDef | ColGroupDef)[];
  domLayout: any;
  paginationPageSize: any;

  constructor(private downloadService: DownloadService, private userService: UserService,
              private alertService: AlertService,) {
    this.domLayout = 'autoHeight';
    this.paginationPageSize = 10;
  }

  private initializeGridOptions() {
    return <GridOptions>{
      rowSelection: 'multiple',
      defaultColDef: {
        flex: 1,
        wrapText: true,
        autoHeight: true,
        sortable: true,
        resizable: true,
        filter: 'agTextColumnFilter',
        filterParams: {
          suppressAndOrCondition: true
        }
      },
      pagination: true,
      paginationPageSize: 10,
      cacheBlockSize: 10,
      rowData: [],
      overlayLoadingTemplate: '<span class="ag-overlay-loading-center">Please wait while your rows are loading</span>',
    };
  }

  ngOnInit() {
    this.currentUrl = location.pathname;
    this.updateColumnDefs();
    this.getDownloadFileslist();
    // this method is used to get the user details, instead of calling to server every time, by using behavioural subject
    this.userService.getUserDetails().subscribe(currentUser => {
      if (AppConstants.isNotNullCondition(currentUser)) {
        this.currentUser = currentUser;
        this.userRole = currentUser.roles[0].id;
        this.businessType = 'mou';
      }
    }, (error) => {
     // this.alertService.info('unable to get current user details');
    });
  }

  updateColumnDefs() {
    this.columnDefs = this.getUpdateMessagesOptionsColumnDefs();
  }

  getDownloadFileslist() {
    this.downloadService.getMouFilesList().subscribe(
      response => {
        this.rowData = response;
        this.gridApi.setGridOption('rowData', this.rowData);
      },
      error => {
        console.log(error);
        this.rowData = {status: 'error', message: error.name + ': ' + error.message};
      }
    );
  }

  onGridReady(params: any) {
    // params.api.sizeColumnsToFit();
    this.gridApi = params.api;
    // this.gridApi.setHeaderHeight(30);
    this.gridApi.setGridOption('headerHeight', 30);
  }

  onDownloadFile(eventObj: any) {
    // TODO
    /*this.alertService.warn('It may take a couple of minutes before the file is downloaded to your desktop for access.');
    this.fileNameSelected = eventObj.fileName;
    this.scacCode = this.downloadForm.get('scacCode').value;
    this.downloadService.getPresignedUrl(eventObj.moduleName, eventObj.fileName, this.scacCode).subscribe(
      response => {
        window.location.href = response;
      },
      error => {
        console.log(error);
        this.fileDownload = {status: 'error', message: error.name + ': ' + error.message};
        this.alertService.error('Your file downloaded is failed. Please try again');
      }
    );*/
  }

  getUpdateMessagesOptionsColumnDefs(): (ColDef | ColGroupDef)[] {
    return [
      <ColDef>
        { headerName: 'Module Name', field: 'moduleName'},
      { headerName: 'File Name', field: 'fileName' },
      { headerName: 'Creation Date', field: 'lastModified'},
      { headerName: 'Size', field: 'fileSize'},
      {
        headerName: 'Download',
        cellRenderer: DownloadAnchorTagComponent,
        cellRendererParams: {
          onClick: this.onDownloadFile.bind(this)
        }
      }
    ];
  }

}
